// TH
export const locale = {
  TRANSLATOR: {
    SELECT: "Select your language"
  },
  MENU: {
    NEW: "new",
    ACTIONS: "Actions",
    CREATE_POST: "Create New Post",
    PAGES: "Pages",
    FEATURES: "Features",
    APPS: "Apps",
    TITLE: "เมนู",
    DASHBOARD: {
      TITLE: "Dashboard"
    },
    PROFILE: {
      TITLE: "ข้อมูลส่วนตัว"
    },
    LOGOUT: {
      TITLE: "ออกจากระบบ"
    },
    COMPANY_MANAGEMENT: {
      TITLE: "จัดการบริษัท",
      COMPANY: "บริษัท"
    },
    CAMPAIGN_MANAGEMENT: {
      TITLE: "จัดกิจกรรม",
      CAMPAIGN: "กิจกรรม"
    },
    CUSTOM_COLOR: "สีพื้นหลักและปุ่มกด",
    USER_MANAGEMENT: {
      TITLE: "จัดการผู้ใช้งาน",
      USER: "ผู้ใช้งาน",
      MANAGEMENT: "กิจกรรมการจัดการขยะ"
    },
    RECEIPT_TYPE_MANAGEMENT: {
      TITLE: "จัดการประเภทใบเสร็จ",
      RECEIPT_TYPE: "ประเภทใบเสร็จ"
    }
  },
  AUTH: {
    TITLE: "Kepttam",
    GENERAL: {
      OR: "Or",
      SUBMIT_BUTTON: "Submit",
      NO_ACCOUNT: "Don't have an account?",
      SIGNUP_BUTTON: "Sign Up",
      FORGOT_BUTTON: "Forgot Password",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "เข้าสู่ระบบ",
      BUTTON: "ตกลง",
      FORM_INVALID: "กรุณาระบุข้อมูลให้ถูกต้อง"
    },
    FORGOT: {
      TITLE: "ลืมรหัสผ่าน",
      DESC: "ระบุอีเมล์เพื่อเปลี่ยนรหัสผ่าน",
      SUCCESS: "Your account has been successfully reset.",
      FORM_INVALID: "กรุณาระบุข้อมูลให้ถูกต้อง"
    },
    UPDATE_PASSWORD: {
      TITLE: "เปลี่ยนรหัสผ่าน",
      DESC: "ระบบได้ส่งรหัสที่ใช้ในการเปลี่ยนรหัสผ่านไปยังอีเมล์ของคุณแล้ว",
      TIME_ALEAT: "กรุณาเปลี่ยนรหัสผ่านภายใน {second} วินาที",
      TIMEOUT: "รหัสหมดอายุ"
    },
    REGISTER: {
      TITLE: "สมัครสมาชิก",
      DESC: "กรอกรายละเอียดบัญชีของคุณ",
      SUCCESS: "บัญชีของคุณถูกสร้างเรียบร้อยแล้ว.",
      NEW_USER: "สมาชิกใหม่?",
      CREATE_ACCOUNT: "สมัครสมาชิกที่นี่",
      CONFIRM_REGISTER:
        "คุณได้สมัครสมาชิกเรียบร้อย กรุณาตรวจสอบอีเมลเพื่อทำการยืนยันการสมัครเข้าใช้งานระบบ"
    },
    INPUT: {
      EMAIL: "อีเมล์",
      FULLNAME: "ชื่อ-สกุล",
      PASSWORD: "รหัสผ่าน",
      CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
      USERNAME: "ชื่อผู้ใช้งาน",
      CODE: "รหัส",
      NEW_PASSWORD: "รหัสผ่านใหม่",
      CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่",
      COMPANY_NAME: "ชื่อบริษัท",
      SUBMIT: "ตกลง",
      CANCEL: "ยกเลิก"
    },
    VALIDATION: {
      INVALID: "ข้อมูลไม่ถูกต้อง",
      REQUIRED: "กรุณาระบุข้อมูล",
      MIN_LENGTH: "กรุณาระบุอย่างน้อย {min} อักษร",
      MAX_LENGTH: "กรุณาระบุไม่เกิน {max} อักษร",
      MIN_MAX_LENGTH: "กรุณาระบุย่างน้อย {min} อักษร และไม่เกิน {max} อักษร",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "ข้อมูลไม่ถูกต้อง",
      CUSTOM_REQUIRED: "กรุณาระบุ {field}"
    }
  },
  PAGE: {
    DEFAULT: {
      TABLE: {
        SEARCH: "ค้นหา",
        CLEAR: "ลบ",
        NEW: "เพิ่ม",
        DATA_NOT_FOUND: "ไม่พบข้อมูล",
        FIELDS: {
          INDEX: "ลำดับ",
          NAME: "ชื่อ",
          TYPEREWORD: "ประเภทของรางวัล",
          MODE_OF_CAMPAIGN: "รูปแบบของกิจกรรม",
          COMPANY: "บริษัท",
          SWITCH: "การใช้งาน",
          USER_TYPE: "ประเภท",
          QUANTITY: "จำนวน",
          POINT: "คะแนน",
          STATUS: {
            TITLE: "สถานะ",
            ACTIVE: "เปิดใช้งาน",
            INACTIVE: "ปิด",
            WAITING_APPROVE: "รอการตรวจสอบ",
            APPROVED: "อนุมัติ",
            REWARD_RECEIVED: "รับของรางวัลแล้ว",
            REWARD_WAITING: "รอรับของรางวัล",
            UNAPPROVED: "ไม่อนุมัติ",
            ALL: "ทั้งหมด"
          },
          ACTION: {
            TITLE: "จัดการ",
            EDIT: "แก้ไข",
            DELETE: {
              TITLE: "ลบ",
              DESC: "ยืนยันการลบข้อมูล"
            }
          }
        },
        PER_PAGE: "จำนวนข้อมูล"
      },
      FORM: {
        TITLE: "ฟอร์ม",
        FIELDS: {
          NAME: "ชื่อ",
          DETAIL: "รายละเอียด",
          START_DATE: "วันที่เริ่มต้น",
          END_DATE: "วันที่สิ้นสุด",
          IMAGE: "รูปภาพ",
          MAIN_IMAGE: "รูปภาพหลัก",
          BANNER_IMAGE: "รูปภาพแบนเนอร์",
          QUANTITY: "จำนวน/มูลค่า",
          POINT: "คะแนน"
        },
        PLACEHOLDER: {
          CHOOSE_DATE: "เลือกวันที่",
          CHOOSE_IMAGE: "เลือกรูปภาพ"
        },
        OPTIONS: {
          ALL: "ทั้งหมด",
          CUSTOM: "กำหนดเอง",
          ON: "เปิดใช้งาน",
          OFF: "ปิด"
        },
        BTN_SUBMIT: "ตกลง",
        BTN_OK: "ตกลง",
        BTN_CANCEL: "ยกเลิก",
        BTN_ADD: "เพิ่ม",
        BTN_PREVIEW: "ตัวอย่าง",
        VALIDATION: {
          INVALID: "ข้อมูลไม่ถูกต้อง",
          REQUIRED: "กรุณาระบุข้อมูล",
          MIN_LENGTH: "กรุณาระบุอย่างน้อย {min} อักษร",
          MAX_LENGTH: "กรุณาระบุไม่เกิน {max} อักษร",
          MIN_MAX_LENGTH:
            "กรุณาระบุย่างน้อย {min} อักษร และไม่เกิน {max} อักษร",
          CHECK_DATA_ALL_TAB: "กรุณากรอกข้อมูลในแต่ละหัวข้อให้ครบ",
          DUPLICATE: "ข้อมูลซ้ำ",
          MIN_VALUE: "กรุณาระบุค่าไม่น้อยกว่า {min}"
        },
        PS_NOTE: {
          MIN_RECORD: "กรุณาระบุอย่างน้อย 1 อย่าง"
        }
      }
    },
    DASHBOARD: {},
    PROFILE: {
      TABLE: {
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์"
        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่"
        }
      }
    },
    COMPANY_MANAGEMENT: {
      TABLE: {
        FIELDS: {
          NAME: "ชื่อ",
          PLAN: "แพ็กเกจ"
        }
      },
      FORM: {
        SECTION_COMPANY: "ข้อมูลบริษัท",
        SECTION_PLAN: "แพ็กเกจ",
        FIELDS: {
          LOGO_IMAGE: "รูปโลโก้",
          NAME: "ชื่อ",
          PLAN: "แพ็กเกจ (Plan)",
          PLAN_EXPIRES: "วันหมดอายุ (ไม่บังคับ)"
        },
        PLAN_HINT:
          "ถ้ายังไม่กำหนด ระบบจะใช้ Starter เป็นค่าเริ่มต้นตามการตั้งค่าเซิร์ฟเวอร์",
        BTN_SAVE_PLAN: "บันทึกแพ็กเกจ",
        PLAN_ON_CREATE_HINT:
          "เลือกแพ็กเกจแล้วกดปุ่มบันทึกด้านล่าง — แพ็กเกจจะถูกบันทึกพร้อมสร้างบริษัท"
      }
    },
    COMPANY: {
      FORM: {
        FIELDS: {
          LOGO_IMAGE: "รูปโลโก้"
        }
      }
    },
    RECEIPT_TYPE: {
      TABLE: {
        FIELDS: {
          LIMIT_VALIDATOR: "จำนวนขั้นต่ำตัวอักษร",
          SORT_NUMBER: "ลำดับการแสดงผล"
        }
      },
      FORM: {
        FIELDS: {
          LIMIT_VALIDATOR: "จำนวนขั้นต่ำตัวอักษร",
          SORT_NUMBER: "ลำดับการแสดงผล",
          GRAPH_COLOR: "สีกราฟ",
          LOGO_IMAGE: "รูปโลโก้",
          PREVIEW_IMAGE: "รูปตัวอย่างใบเสร็จ",
          OCR_SYSTEM_PROMPT: "OCR Prompt (คำแนะนำสำหรับ AI อ่านใบเสร็จประเภทนี้)"
        }
      }
    },
    CAMPAIGN: {
      TABLE: {
        BUTTON: {
          NEW_CAMPAIGN_RECEIPT: "เพิ่มกิจกรรมใบเสร็จ"
        },
        FIELDS: {
          CAMPAIGN_URL: "URL กิจกรรม",
          START_DATE: "วันที่เริ่ม",
          END_DATE: "วันที่สิ้นสุด",
          CREATED_AT: "วันที่",
          CUSTOMER: "ลูกค้า",
          RECEIPT_TYPE: "ประเภทใบเสร็จ",
          REWARD: "รางวัล",
          POINT: "คะแนน",
          VERIFY_CODE: "รหัสตรวจสอบ",
          REMARK: "หมายเหตุ",
          ANNOUNCE_DATE: "วันที่ประกาศ"
        }
      },
      FORM: {
        FIELDS: {
          LANDING_IMAGE: "รูปภาพหน้าแรก",
          POLICY_IMAGE: "รูปภาพหัวข้อเงื่อนไข",
          POLICY: "เงื่อนไข",
          POLICY_NOT_ACCEPT: "ไม่ยอมรับเงื่อนไข"
        },
        HINT: {
          IS_ACTIVE: "กรุณาอัพเดท LINE LIFF ID เพื่อทำการเปิดใช้งานกิจกรรม",
          BANNER_SCALE: "ขนาดรูปที่เหมาะสมสำหรับแบนเนอร์ 414 x 165"
        },
        MODAL: {
          PRODUCT_TITLE: "ฟอร์มสินค้า",
          REWARD_TITLE: "ฟอร์มรางวัล",
          CUSTOMER_RECEIPT: "ข้อมูลใบเสร็จ",
          CUSTOMER_RECEIPT_REWARD: "ข้อมูลการแลกรางวัล",
        },
        CAMPAIGN_RECEIPT: {
          TITLE: "ฟอร์มกิจกรรมใบเสร็จ",
          TAB: {
            GENERAL: "ทั่วไป",
            RECEIPT: "ประเภทใบเสร็จ",
            PRODUCT: "สินค้า",
            REWARD: "ของรางวัล",
            CUSTOMER: "ประวัติการส่งใบเสร็จ",
            REFERRAL: "ประวัติแนะนำเพื่อน",
            SEND_MESSAGE: "ส่งข้อความ",
            RECEIPT_REWARD: "ประวัติการแลกรางวัล",
            DASHBOARD: "Dashboard",
            LANDING: "หน้าแรก",
            TERM_AND_CONDITION: "ข้อกำหนดและเงื่อนไข (PDPA)",
            ANNOUNCEMENT: "ประกาศรางวัล",
            MEMBERS: "สมาชิก",
            SEGMENTS: "กลุ่มลูกค้า"
          },
          MEMBERS: {
            TOTAL_LABEL: "จำนวนสมาชิกทั้งหมด",
            TOTAL_POINTS_LABEL: "จำนวนคะแนนทั้งหมด",
            TOTAL_REDEMPTIONS_LABEL: "จำนวนการแลกของรางวัล",
            LOADING_COUNT: "กำลังนับ…",
            COUNT_UNAVAILABLE: "ไม่สามารถโหลดจำนวนสมาชิกได้",
            POINTS_UNAVAILABLE: "ไม่สามารถโหลดยอดคะแนนรวมได้",
            REDEMPTIONS_UNAVAILABLE: "ไม่สามารถโหลดจำนวนการแลกของรางวัลได้",
            JOINED_FILTER: "ช่วงที่เข้าร่วม",
            FILTER_ALL: "ทั้งหมด",
            FILTER_NEW_TODAY: "ใหม่วันนี้",
            FILTER_NEW_MONTH: "ใหม่เดือนนี้",
            COL_NAME: "ชื่อ",
            COL_PHONE: "เบอร์โทร",
            COL_JOINED: "วันที่เข้าร่วมแคมเปญ",
            COL_CUSTOMER_REGISTERED: "วันที่ลงทะเบียน (จากลูกค้า)",
            ACTION_PROFILE: "โปรไฟล์",
            ACTION_POINTS: "ประวัติคะแนน",
            ACTION_REDEMPTION: "ประวัติแลกรางวัล",
            ACTION_VIEW_DETAIL: "ดูรายละเอียด",
            PAGE_MEMBER_DETAIL_TITLE: "รายละเอียดสมาชิก",
            TAB_PROFILE: "โปรไฟล์",
            TAB_POINTS: "ประวัติการส่งใบเสร็จ",
            TAB_REDEMPTION: "ประวัติแลกรางวัล",
            TAB_QR_REDEMPTION_HISTORY: "ประวัติการสแกนแลกแต้ม",
            LIST_UNAVAILABLE: "ยังโหลดรายชื่อไม่ได้ (รอ API ฝั่งเซิร์ฟเวอร์)",
            BTN_BACK: "กลับไปกิจกรรม",
            PAGE_PLACEHOLDER:
              "หน้านี้เตรียมไว้สำหรับแสดงรายละเอียดเมื่อ API พร้อมใช้งาน",
            PAGE_PROFILE_TITLE: "โปรไฟล์สมาชิก",
            PAGE_POINTS_TITLE: "ประวัติสะสมคะแนน",
            PAGE_REDEMPTION_TITLE: "ประวัติการแลกรางวัล",
            MEMBER_REF: "สมาชิก #",
            PROFILE_CUSTOMER: "ข้อมูลลูกค้า",
            PROFILE_POINTS: "คะแนนสะสม",
            MEMBER_JOINED: "เข้าร่วมเมื่อ",
            LOAD_ERROR_DETAIL: "โหลดข้อมูลไม่สำเร็จ",
            COL_POINT: "คะแนน",
            COL_VERIFY_CODE: "รหัสอ้างอิง",
            COL_VERIFY_CODE_RECEIPT: "รหัสตรวจสอบ",
            COL_RECEIPT_TYPE: "ประเภทใบเสร็จ",
            COL_STATUS: "สถานะ",
            COL_REMARK: "หมายเหตุ",
            COL_REWARD: "รางวัล",
            COL_DATE: "วันที่"
          },
          SEGMENTS: {
            FILTER_HINT:
              "นับเฉพาะใบเสร็จที่อนุมัติแล้ว ตามวันที่สร้างใบเสร็จในช่วงที่เลือก (ถ้าไม่ระบุช่วง จะนับทุกช่วง)",
            MIN_RECEIPTS_LABEL: "จำนวนใบเสร็จขั้นต่ำ (ในช่วงที่เลือก)",
            BTN_EXPORT: "ส่งออก Excel",
            COL_RECEIPT_COUNT: "จำนวนใบเสร็จที่นับในช่วง",
            COL_RECEIPT_LIST: "เลขที่ใบเสร็จ / วันที่ส่ง",
            START_DATE_LABEL: "วันเริ่ม (วันที่ใบเสร็จ)",
            END_DATE_LABEL: "วันสิ้นสุด (วันที่ใบเสร็จ)",
            BTN_LOAD: "โหลดรายการ",
            LIST_UNAVAILABLE: "ยังโหลดรายการไม่ได้",
            EXPORT_FAILED: "ส่งออกไฟล์ไม่สำเร็จ",
            MEMBER_CAP_LABEL: "Member Cap Usage",
            CAP_IN_USE: "ใช้งานอยู่",
            CAP_PLAN: "Plan: {plan} · เหลือ {n} คน",
            INSIGHT_TITLE: "INSIGHT ที่น่าสนใจ",
            INSIGHT_CTA: "ดูแผนแนะนำ →",
            INSIGHT_HTML:
              "กลุ่ม <strong style=\"color:#fbbf24\">At Risk เพิ่มขึ้น 8.1%</strong> เดือนนี้ — ลูกค้า 1,422 คนกำลังจะหายไป " +
              "ลองส่ง win-back coupon ก่อนกลายเป็น Lapsed · " +
              "ใกล้ชน Member Cap แล้ว แนะนำพิจารณา <strong style=\"color:#fbbf24\">upgrade เป็น Pro</strong>",
            SECTION_TABS_LABEL: "02 · แบ่งกลุ่มตามมุมมอง",
            SECTION_TABS_HINT: "— เลือก tab ตามวัตถุประสงค์",
            TAB_ENGAGEMENT: "A · By Engagement",
            TAB_RECEIPT_ACTIVITY: "B · By Receipt Activity",
            TAB_DEMOGRAPHIC: "C · By Demographic",
            TAB_REWARD: "D · By Reward",
            ENG_CHART_TITLE: "สัดส่วนสมาชิกตาม ENGAGEMENT",
            TREND_ACTIVE_LABEL: "Active — แนวโน้ม",
            RECEIPT_DIST_TITLE: "📄 จำนวนใบเสร็จต่อคน",
            RECEIPT_DIST_SUB: "รวมทุกแคมเปญ · {n} คน",
            RECEIPT_BREAK_TITLE: "รวมใบเสร็จที่ส่งทั้งหมดเดือนนี้ — {n} ใบ",
            SPEND_TITLE: "💰 ยอดซื้อรวมต่อคน",
            SPEND_SUB: "เฉพาะใบเสร็จที่ approve · {n} คน",
            SPEND_COL_TIER: "TIER",
            SPEND_COL_RANGE: "ช่วงยอด",
            SPEND_COL_COUNT: "จำนวน",
            PARETO_NOTE: "💡 ลูกค้า HIGH tier {pct}% สร้างยอดรวม {revenue} หรือ {share}% ของยอดทั้งหมด",
            FREQ_TITLE: "📅 ความถี่เฉลี่ยในการส่งใบเสร็จ",
            FREQ_SUB: "เฉพาะคนที่ส่ง ≥2 ใบ · {n} คน",
            FRAUD_TITLE: "พบสมาชิก {n} คน ที่อัตรา Reject ผิดปกติ",
            FRAUD_BODY:
              "สมาชิกเหล่านี้มีอัตราใบเสร็จถูก reject สูงกว่า {threshold}% " +
              "(ค่าเฉลี่ยฐานทั้งหมด {average}%) " +
              "อาจเป็นสัญญาณของการพยายามใช้ใบเสร็จซ้ำ, ปลอม หรือถ่ายไม่ครบถ้วน — ควรตรวจสอบ",
            FRAUD_CTA: "ดูรายชื่อ {n} คน →",
            FOOTER_CRITERIA: "เกณฑ์การจัดกลุ่ม:",
            FOOTER_CALC:
              "ระบบคำนวณ segment อัตโนมัติทุก 24 ชม. โดยอ้างอิงวันที่ส่งใบเสร็จล่าสุดและ campaign ที่ active",
            FOOTER_ACTIVE_DEF: "= ส่งใบเสร็จที่ผ่านการอนุมัติแล้วใน 30 วันล่าสุด",
            FOOTER_CAP_DEF: "นับสะสมตลอดอายุ account ตาม pricing policy v2.2",
            KPI_TOTAL_LABEL: "Total Members",
            KPI_TOTAL_SUFFIX: "คน",
            KPI_TOTAL_META: "เทียบเดือนก่อน · +912 คน",
            KPI_ACTIVE_LABEL: "Active",
            KPI_ACTIVE_SUB: "30 วัน",
            KPI_ACTIVE_META: "37.7% ของฐาน",
            KPI_RISK_LABEL: "At Risk",
            KPI_RISK_SUB: "30–60 วัน",
            KPI_RISK_META: "ต้องเร่ง win-back",
            KPI_LAPSED_LABEL: "Lapsed",
            KPI_LAPSED_SUB: "60+ วัน",
            KPI_LAPSED_META: "35.9% ของฐาน",
            SEG_NEW_NAME: "New",
            SEG_NEW_DEF: "สมัครภายใน 7 วัน · ยังไม่ส่งใบเสร็จ",
            SEG_NEW_ACTION: "Onboard",
            SEG_ACTIVE_NAME: "Active",
            SEG_ACTIVE_DEF: "ส่งใบเสร็จ ≥1 ใบ ใน 30 วันล่าสุด",
            SEG_ACTIVE_ACTION: "Upsell",
            SEG_RISK_NAME: "At Risk",
            SEG_RISK_DEF: "เคย active แต่เงียบ 30–60 วัน",
            SEG_RISK_ACTION: "Win-back",
            SEG_LAPSED_NAME: "Lapsed",
            SEG_LAPSED_DEF: "เงียบเกิน 60 วัน",
            SEG_LAPSED_ACTION: "Reactivate",
            SEG_VIP_NAME: "VIP",
            SEG_VIP_DEF: "Top 10% ใบเสร็จสะสม / ยอดซื้อสูง",
            SEG_VIP_ACTION: "Reward",
            DIST_0: "0 ใบ",
            DIST_1: "1 ใบ",
            DIST_2_5: "2–5 ใบ",
            DIST_6_PLUS: "6+ ใบ",
            FREQ_WEEKLY: "รายสัปดาห์",
            FREQ_MONTHLY: "รายเดือน",
            FREQ_BI_MONTHLY: "2–3 เดือน/ครั้ง",
            FREQ_OCCASIONAL: "นานๆ ครั้ง",
            FREQ_LOYAL_TAG: "⭐ Loyal"
          },
          TAB_DASHBOARD: {
            FROM: "จาก",
            TO: "ถึง",
            STATUS: "สถานะ",
            SEARCH: "ค้นหา",
            CUSTOMER_PER_HOUR: "จำนวนผู้เล่น 1 ชั่วโมงย้อนหลัง",
            CURRENT_CUSTOME: "จำนวนผู้เล่นในวันนี้",
            CUSTOMER_PER_CAMPAIGN: "จำนวนผู้ส่งใบเสร็จ",
            CAMPAIGN_CUSTOMER_REGISTER: "จำนวนผู้ลงทะเบียนเข้าร่วม",
            CAMPAIGN_LINE_X: "วันที่",
            CAMPAIGN_LINE_Y: "จำนวนผู้เล่น",
            PEAK_LINE_Y: "จำนวนใบเสร็จ",
            OLDCUSTOMERS_LINE_Y: "จำนวนผู้เล่นเก่า",
            REG_PER_DAY_LINE_X: "วันที่",
            REG_PER_DAY_LINE_Y: "จำนวนผู้สมัคร",
            REG_PER_DAY_EXPORT_COUNT: "จำนวนผู้สมัครในวันนั้น",
            REG_PER_DAY_EXPORT_NAMES: "รายชื่อผู้สมัคร",
            CUSTOMER_LINE_EXPORT_USER_COUNT: "จำนวนผู้ใช้งาน",
            CUSTOMER_LINE_EXPORT_RECEIPT_COUNT: "จำนวนใบเสร็จทั้งหมดที่ส่ง",
            CUSTOMER_LINE_EXPORT_USER_NAMES: "รายชื่อผู้ใช้งาน",
            RECEIPT_TYPE: "ประเภทของใบเสร็จ",
            RECEIPT_TYPE_EXPORT_COL_TYPE: "ประเภทใบเสร็จ",
            RECEIPT_TYPE_EXPORT_COUNT: "จำนวนใบเสร็จสะสม",
            RECEIPT_TYPE_EXPORT_SENDERS: "รายชื่อผู้ส่งใบเสร็จ",
            UNAPPROVED: "สาเหตุที่ไม่อนุมัติใบเสร็จ",
            UNAPPROVED_EXPORT_COL_REASON: "สาเหตุที่ไม่อนุมัติ",
            UNAPPROVED_EXPORT_COUNT: "จำนวนใบเสร็จที่ถูกปฏิเสธ (ตามสาเหตุ)",
            UNAPPROVED_EXPORT_OWNERS:
              "รายชื่อเจ้าของใบเสร็จที่แอดมินไม่อนุมัติ",
            REWARD: "แลกของรางวัล",
            RECEIPT_REWARD: "เลือกของรางวัล",
            RECEIPT_REWARD_POINT: "สิทธิ์แลกของรางวัล",
            REWARD_REDEEM_EXPORT_COL_NAME: "รายการของรางวัล",
            REWARD_REDEEM_EXPORT_TOTAL_VALUE:
              "มูลค่ารวมของรางวัลแต่ละรายการ (คะแนน)",
            REWARD_REDEEM_EXPORT_COUNT: "จำนวนการใช้สิทธิ์แลกของรางวัล",
            REWARD_REDEEM_EXPORT_NAMES: "รายชื่อผู้แลกสิทธิ์ของรางวัล",
            RECEIPT_REWARD_POINT_EXPORT_COL_NAME: "รายการสิทธิ์แลกรางวัล",
            RECEIPT_REWARD_POINT_EXPORT_TOTAL_VALUE:
              "มูลค่ารวมสิทธิ์ (คะแนน) ตามกราฟ",
            RECEIPT_REWARD_POINT_EXPORT_NAMES:
              "รายชื่อลูกค้าที่มีสิทธิแลกรางวัลเดียวกัน",
            TOTAL: "ทั้งหมด",
            DOWNLOADEXCEL: "ดาวน์โหลด Excel"
          },
          TAB_ANNOUNCE_REWARD: {
            ANNOUNCE_DATE: "วันที่ประกาศ",
            ANNOUNCE_CUSTOMER: "รายชื่อผู้ได้รับรางวัล",
            LABEL_DATE: "เลือกวันที่",
            LABEL_IMAGE: "เลือกรูปภาพ",
            BTN_REMOVE_IMAGE: "ลบรูปภาพ",
            CUSTOMER: "รายชื่อ",
            SEND_MESSAGE: "ส่งข้อความ",
            CUSTOMER_FORM_TITLE: "เพิ่มรายชื่อ",
            CUSTOMER_NAME: "ชื่อผู้ได้รับรางวัล",
            PHONE_NUMBER: "เบอร์โทรศัพท์",
            RECEIPT_CODE: "รหัสใบเสร็จ",
            REWARD: "ระบุรางวัล",
            MESSAGE_DATE: "วันที่ส่ง",
            MESSAGE: "ข้อความ",
            BUTTON_ADD: "บันทึก",
            INPUT_REWARD_INFO: "ระบุรายละเอียดอื่นๆของรางวัลที่ได้รับ",
            INPUT_MESSAGE_INFO: "ข้อความที่กรอกจะแสดงในบรรทัดสุดท้าย",
            LABEL_EX_MESSAGE: "ตัวอย่างข้อความ",
            EX_MESSAGE:
              "ยินดีด้วย คุณเป็นผู้โชคดีได้รับรางวัลในรอบ xxxxx<br />จากใบเสร็จหมายเลข xxxxx<br />รางวัลที่ได้คือ xxxxx(xxxxx)<br />",
            CONFIRM_SEND_MESSAGE: "คุณต้องการจะส่งข้อความนี้ใช่หรือไม่?",
            INVALID_RECEIPT_CODE: "รหัสใบเสร็จไม่ถูกต้อง",
            CONFIRM_ADD_CUSTOMER: "คุณต้องการจะเพิ่มรายชื่อนี้ใช่หรือไม่?",
            CAMPAIGN_REWARD_NAME: "ของรางวัล"
          },
          ACTIVE_WARNING:
            'เมื่อทำการอัพเดท "LINE LIFF ID" แล้ว<br> กิจกรรมนี้จะทำการเปิดใช้งานอัตโนมัติเมื่อถึงวันที่เริ่มต้นที่ตั้งไว้',
          CONFRIM_ENABLE:
            "คุณต้องการที่ <span style='color:green'>เปิด</span> การใช้งานกิจกรรม ใช่หรือไม่",
          CONFRIM_DISABLE:
            "คุณต้องการที่ <span style='color:red'>ปิด</span> การใช้งานกิจกรรม ใช่หรือไม่",
          CONFIRM_SUBMIT_WITH_DUPLICATE:
            "ใบเสร็จนี้มีรหัสตรวจสอบซ้ำกับใบเสร็จที่เคยอนุมัติ คุณต้องการยืนยันที่จะบันทึกข้อมูล ใช่หรือไม่?",
          BTN_REVERT_APPROVE: "ถอนการอนุมัติ",
          CONFIRM_REVERT_APPROVE_TITLE: "ยืนยันการถอนการอนุมัติ?",
          CONFIRM_REVERT_APPROVE:
            'สถานะจะถูกเปลี่ยนกลับเป็น "รอการตรวจสอบ" และคะแนนที่ลูกค้าได้รับจากใบเสร็จนี้จะถูกหักคืน คุณต้องการดำเนินการต่อหรือไม่?',
          FIELDS: {
            ENABLE_VALUE_BASED_POINTS: "เปิดใช้คะแนนตามมูลค่า",
            VALUE_BASED_AMOUNT: "มูลค่า (บาท)",
            VALUE_BASED_POINTS: "คะแนน",
            ENABLE_REFERRAL: "เปิดใช้แนะนำเพื่อน (Ref Code)",
            REFERRAL_HINT:
              "ลูกค้าแต่ละคนจะได้รหัสแนะนำเพื่อนไว้แชร์ เมื่อมีคนกรอกรหัสตอนสมัคร ทั้งคนเชิญและคนเข้าร่วมจะได้คะแนนตามที่กำหนด",
            REFERRAL_INVITER_POINT: "คะแนนคนเชิญ",
            REFERRAL_INVITEE_POINT: "คะแนนคนเข้าร่วม",
            LINE_MESSAGE_TOKEN: "LINE MESSAGE TOKEN",
            TERM_AND_CONDITION: "กติกา",
            CUSTOMER: "ลูกค้า",
            RECEIPT_TYPE: "ประเภทใบเสร็จ",
            DESELECT_ALL_RECEIPT_TYPES: "ยกเลิกทั้งหมด",
            REWARD: "รางวัล",
            IS_APPROVE: "การอนุมัติ",
            REASON_NOT_APPROVE: "เหตุผลที่ไม่อนุมัติ",
            UNAPPROVED_REASON_REMARK: "เหตุผลอื่นๆ",
            POINT: "คะแนน",
            VERIFY_CODE: "รหัสตรวจสอบ",
            REMARK: "หมายเหตุ",
            RECEIPT_VERIFY_REGEX: "ตรวจสอบเลขใบเสร็จตามรูปแบบ (regex)",
            RECEIPT_VERIFY_REGEX_PLACEHOLDER: "เช่น ^[A-Z0-9-]+$",
            RECEIPT_VERIFY_REGEX_HINT:
              "ไม่บังคับ ใช้กำหนดรูปแบบข้อความเลขที่ใบเสร็จหลังอ่านค่า เพื่อช่วยตรวจว่าตรงตามที่ต้องการหรือไม่"
          }
        },
        CAMPAIGN_REWARD: {
          IMAGE: "รูปภาพของรางวัล",
          QUANTITY: "จำนวน",
          POINT: "แต้มที่ใช้แลก",
          DESCRIPTION: "รายละเอียด"
        }
      }
    },
    CUSTOM_COLOR: {
      FORM: {
        FIELDS: {
          BACKGROUND_COLOR: "สีพื้นหลัง",
          BUTTON_COLOR: "สีหัวข้อและสีปุ่มกด",
          BUTTON_TEXT_COLOR: "สีตัวอักษรปุ่มกด"
        }
      }
    },
    CUSTOMER_POINT: {
      TABLE: {
        FIELDS: {
          CUSTOMER: "ลูกค้า",
          POINT: "คะแนน"
        },
        TOTAL_LABEL: "จำนวนทั้งหมด %s คน"
      },
      FORM: {
        FIELDS: {
          MESSAGE: "ข้อความ",
          IMAGE: "รูปภาพ"
        },
        HINT: {
          MAX_FILE: "กรุณากรอกขนาดรูปไม่เกิน 1 MB"
        }
      }
    },
    CAMPAIGN_REFERRAL: {
      TABLE: {
        FIELDS: {
          INVITER: "คนเชิญ",
          INVITEE: "คนเข้าร่วม",
          INVITER_POINT: "คะแนนคนเชิญ",
          INVITEE_POINT: "คะแนนคนเข้าร่วม"
        }
      }
    },
    CAMPAIGN_RECEIPT_REWARD: {
      TABLE: {
        FIELDS: {
          CREATED_AT: "วันที่",
          CUSTOMER: "ลูกค้า",
          REWAED_NAME: "รางวัล"
        }
      },
      FORM: {
        FIELDS: {
          CUSTOMER: "ลูกค้า",
          RECEIPT_REWARD: "รางวัล",
          IS_APPROVE: "การอนุมัติ",
          IS_RECEIVED: "สถานะการรับของรางวัล",
          RECEIVED_AT: "วันที่รับของรางวัล",
          RECEIVED_UPDATED_BY: "แก้ไขโดย",
          REMARK: "หมายเหตุ"
        },
        HINT: {
          MAX_FILE: "กรุณากรอกขนาดรูปไม่เกิน 1 MB"
        }
      }
    },
    CAMPAIGN_RECEIPT_MESSAGE: {
      TABLE: {
        FIELDS: {
          CONDITION: "เงื่อนไข",
          IMAGE_PATH: "รูปภาพ",
          MESSAGE: "ข้อความ",
          NUMBER_SEND: "จำนวนผู้รับ (คน)"
        }
      }
    },
    USER: {
      TABLE: {
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์"
        }
      },
      FORM: {
        TABS: {
          DATA: "ข้อมูล",
          PASSWORD: "รหัสผ่าน"
        },
        FIELDS: {
          FULLNAME: "ชื่อ - สกุล",
          EMAIL: "อีเมล์",
          USER_TYPE: "ประเภทผู้ใช้งาน",
          PHONE_NUMBER: "เบอร์โทร",
          COMPANY: "บริษัท",
          PASSWORD: "รหัสผ่าน",
          CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
          OLD_PASSWORD: "รหัสผ่านเก่า",
          NEW_PASSWORD: "รหัสผ่านใหม่",
          CONFIRM_NEW_PASSWORD: "ยืนยันรหัสผ่านใหม่"
        }
      }
    }
  },
  RESPONSE_MESSAGE: {
    ERROR_OCCURRED: "ระบบเกิดข้อผิดพลาด",
    USER_NOT_FOUND: "ไม่พบผู้ใช้งาน",
    EMAIL_DUPLICATE: "อีเมล์นี้มีผู้ใช้งานแล้ว",
    CODE_EXPIRED: "รหัสหมดอายุการใช้งาน",
    SAVE_DATA_SUCCESS: "บันทึกข้อมูลสำเร็จ",
    SAVE_DATA_SUCCESS_LINE_TOKEN_AUTH_FAILE:
      "<p style='color:red;'>ข้อความสถานะจะไม่ถูกแจ้งเนื่องจาก Line Message Token ไม่ถูกต้อง กรุณาตรวจสอบใหม่อีกครั้ง</p>",
    SAVE_DATA_FAILURE: "บันทึกข้อมูลไม่สำเร็จ",
    DELETE_DATA_SUCCESS: "ลบข้อมูลสำเร็จ",
    DELETE_DATA_FAILURE: "ลบข้อมูลไม่สำเร็จ",
    DATA_INVALID: "ข้อมูลไม่ถูกต้อง",
    MISSING_PARAMETER: "ข้อมูลไม่ครบ",
    FORBIDDEN: "ไม่มีสิทธิ์ดำเนินการ",
    DATA_NOT_FOUND: "ไม่พบข้อมูล",
    DATA_DUPLICATE: "มีข้อมูลนี้แล้ว",
    SYSTEM_ERROR: "ระบบเกิดข้อผิดพลาด",
    COMPANY_NAME_DUPLICATE: "ชื่อบริษัทนี้ถูกใช้งานแล้ว",
    VERIFY_CODE_DUPLICATE: "รหัสตรวจสอบนี้ถูกใช้งานแล้ว",
    CANNOT_SEND_MESSAGE: "ระบบเกิดข้อผิดพลาด ไม่สามารถส่งข้อความได้",
    PLAN_REQUIRED_PRO: "ฟีเจอร์นี้ใช้ได้เฉพาะแพ็กเกจ Pro",
    TIER_POINT_GAP: "ช่วงคะแนนของแต่ละระดับสมาชิกต้องต่อเนื่องกัน",
    TIER_TOP_MUST_BE_UNLIMITED: "ระดับสูงสุดต้องไม่จำกัดเพดานคะแนน",
    VERSION_CONFLICT: "ข้อมูลมีการเปลี่ยนแปลงจากผู้ใช้อื่น กรุณารีเฟรชหน้าจอแล้วลองใหม่อีกครั้ง",
    TIER_LOWEST_MUST_BE_ACTIVE: "ระดับสมาชิกเริ่มต้นต้องเปิดใช้งานเสมอ",
    IMAGE_INVALID_TYPE: "ประเภทไฟล์รูปภาพไม่ถูกต้อง (รองรับเฉพาะ PNG, JPG หรือ WebP)",
    IMAGE_TOO_LARGE: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB"
  },
  LOADING: "กำลังโหลด"
};
